import { REMOVE_ATTACHMENT } from "../action.js";

export const removeAttachment = (fileName) => {
    return (dispatch) => {
        dispatch({ type: REMOVE_ATTACHMENT, payload: fileName });
    };
};